<div attr.name="CellSession_{{ item.name }}" class="tCol clickCol desktop" id="CellSession_{{ item.id }}">
  <!-- for some reason using [ngClass] does not seem to want to work here -->
  @if (item.sessionIdentityId != null && item.sessionActive) {
    <span class="icon-NFAuthConnected"></span>
  }
  @if (item.sessionIdentityId != null && !item.sessionActive) {
    <span class="icon-NFAuthDisconnected"></span>
  }
</div>
